module.exports = __webpack_public_path__ + "img/gebratenesrindfleischmithintergrund.20c8737b.jpg";